import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Pagination from '../Pagination/Pagination';
import "./VentilatorVitalDataDesktopView.scss";
import { ACTIVE_PARAMETERS, PARAMETER_UNIT_IDS, VENTI_PAGE_TEMPLATE, VENTILATOR_ADDITIONAL_FEATURES } from '../../common/ENUMS/PARAMETER_ENUM';
import offlineIcon from "../../common/icons/svg/ventilator-offline.svg"
import standbyIcon from "../../common/icons/svg/no-ventilation.svg"
import { alarmBackground } from '../../common/utils/CommonUtils';
import VentilatorSetParams from '../VentilatorSetParams/VentilatorSetParams';
import VentilatorChart from '../VentilatorChart/VentilatorChart.jsx';
import DevicesTab from "../../container/PatientRightPanel/MachineTabs/DevicesTab.jsx";
import { formatValue, formatAlarmLimits } from '../../common/utils/CommonUtils.js';




const VentilatorVitalDataDesktopView = ({
    props,
    currentPage,
    setCurrentPage,
    visibleParameters,
}) => {

    /* ---------- checkModuleConditions ---------- */
    const checkModuleConditions = ({ currentPage, card_no, parameter_id }) => {

        const hasCo2 = !!props?.ventilatorAdditionalFeaturesData?.find(
            f => f.id === VENTILATOR_ADDITIONAL_FEATURES?.capnography
        )?.on;

        const hasSpo2 = !!props?.ventilatorModuleConnectionStatus?.spo2;

        if (hasCo2) {
            if (currentPage === 1 && card_no === 10) parameter_id = 104009;
            if (currentPage === 1 && card_no === 11) parameter_id = 104402;
            if (currentPage === 1 && card_no === 12) parameter_id = 104416;
            if (currentPage === 1 && card_no === 13) parameter_id = 104422;
        }
        else if (hasSpo2) {
            if (currentPage === 1 && card_no === 10) parameter_id = 104009;
            if (currentPage === 1 && card_no === 11) parameter_id = 104301;
            if (currentPage === 1 && card_no === 12) parameter_id = 104302;
            if (currentPage === 1 && card_no === 13) parameter_id = 104303;
        }

        return parameter_id;
    };

    const LeftBoxParamContainer = ({ currentPage, card_no, borderRight }) => {

        let parameter_id = VENTI_PAGE_TEMPLATE?.[currentPage]?.[card_no]
        parameter_id = checkModuleConditions({
            currentPage,
            card_no,
            parameter_id
        });

        const paramData = visibleParameters?.find(item => item.id === parameter_id);
        const hasValidUnit = PARAMETER_UNIT_IDS?.[paramData?.unit]?.UNIT != null;

        const alarmClass =
            hasValidUnit && paramData?.alarms?.length
                ? alarmBackground(paramData?.alarms)
                : "";





        // Safe values
        const title = ACTIVE_PARAMETERS?.[paramData?.id]?.TITLE ?? "-"
        let fontColor = ACTIVE_PARAMETERS?.[paramData?.id]?.fontColour ?? "#FFFFFF"
        const unit = hasValidUnit ? PARAMETER_UNIT_IDS?.[paramData?.unit]?.UNIT ?? "-" : "-";

        // Extract alarm limit data safely
        const alarmLimit = paramData?.alarm_limit ?? [];
        const [lower, upper, lowerEnabled, upperEnabled] = alarmLimit;

        // Conditionally show limits only if flag is true
        const upperLimit =
            hasValidUnit && upper != null
                ? (upperEnabled ? formatAlarmLimits(upper, parameter_id, props?.ventilatorPatientModeAlarmProfileData?.patientType) : "OFF")
                : null;

        const lowerLimit =
            hasValidUnit && lower != null
                ? (lowerEnabled ? formatAlarmLimits(lower, parameter_id, props?.ventilatorPatientModeAlarmProfileData?.patientType) : "OFF")
                : null;

        const value =
            hasValidUnit && paramData?.value != null
                ? formatValue(parameter_id, paramData.value, paramData.precision)
                : "-";

        return (
            <div
                className={`vital-parameter-left  ${alarmClass}`}
                style={
                    !borderRight
                        ? { borderRight: "none" }
                        : { borderRight: "0.15vw solid #1F1F1F" }
                }
            >
                <div className="left-box-header">
                    <div className="param-name">
                        <div className={`param-name-text ${alarmClass}`}>{title}</div>
                        <div className={`param-unit-text ${alarmClass}`}>{unit}</div>
                    </div>
                    <div className="param-name">
                        <div className={`param-st-val ${alarmClass}`}>{upperLimit}</div>
                        <div className={`param-st-val ${alarmClass}`}>{lowerLimit}</div>
                    </div>
                </div>
                <div className={`param-val ${alarmClass}`} style={{ color: fontColor }}>{value}</div>

            </div >
        );
    };


    const RightBoxParamContainer = ({ currentPage, card_no, borderBottom }) => {

        let parameter_id = VENTI_PAGE_TEMPLATE?.[currentPage]?.[card_no]
        parameter_id = checkModuleConditions({
            currentPage,
            card_no,
            parameter_id
        });

        const paramData = visibleParameters?.find(item => item.id === parameter_id);
        const hasValidUnit = PARAMETER_UNIT_IDS?.[paramData?.unit]?.UNIT != null;

        const alarmClass =
            hasValidUnit && paramData?.alarms?.length
                ? alarmBackground(paramData?.alarms)
                : "";


        // Safe title & unit
        const title = ACTIVE_PARAMETERS?.[paramData?.id]?.TITLE ?? "--";
        let fontColor = ACTIVE_PARAMETERS?.[paramData?.id]?.fontColour ?? "#FFFFFF"

        const unit = hasValidUnit ? PARAMETER_UNIT_IDS?.[paramData?.unit]?.UNIT ?? "--" : "--";

        // Extract alarm limit info safely
        const alarmLimit = paramData?.alarm_limit ?? [];
        const [lower, upper, lowerEnabled, upperEnabled] = alarmLimit;

        // Conditionally show limits only if enabled

        const upperLimit =
            hasValidUnit && upper != null
                ? (upperEnabled ? formatAlarmLimits(upper, parameter_id, props?.ventilatorPatientModeAlarmProfileData?.patientType) : "OFF")
                : null;

        const lowerLimit =
            hasValidUnit && lower != null
                ? (lowerEnabled ? formatAlarmLimits(lower, parameter_id, props?.ventilatorPatientModeAlarmProfileData?.patientType) : "OFF")
                : null;

        let value =
            hasValidUnit && paramData?.value != null
                ? formatValue(parameter_id, paramData.value, paramData.precision)
                : "-";

        return (
            <div className={`vital-parameter-right-small ${alarmClass}`} style={
                !borderBottom
                    ? { borderBottom: "none" }
                    : { borderBottom: "0.15vw solid #1F1F1F" }
            }>
                <div className="right-box-param">
                    <div className={`right-box-param-name ${alarmClass}`}>{title}</div>
                    <div className={`right-box-param-unit ${alarmClass}`}>{unit}</div>
                </div>

                <div className={`right-param-val ${alarmClass}`} style={{ color: fontColor }}>
                    {value}
                </div>
                <div className="right-st-container">
                    <div className={`param-st-val${alarmClass}`}>{upperLimit}</div>
                    <div className={`param-st-val ${alarmClass}`}>{lowerLimit}</div>
                </div>
            </div>
        );
    };

    /* ---------- CO2 Page Protection ---------- */
    useEffect(() => {
        const hasCo2 = !!props?.ventilatorAdditionalFeaturesData?.find(
            f => f.id === VENTILATOR_ADDITIONAL_FEATURES?.capnography
        )?.on;

        if (!hasCo2 && currentPage === 4) {
            setCurrentPage(1);
        }
    }, [props?.ventilatorAdditionalFeaturesData]);

    if (props?.ventilatorHeartbeat?.isConnected) {

        if (props?.ventilatorHeartbeat?.user_enabled) {
            {
                return (
                    <div className='ventilator-vitals-container'>
                        <div className='waveform-and-footer-container'>
                            <div className='ventilator-alarms'>
                                {props?.ventilatorStandby?.ventilationStatus &&
                                    <DevicesTab
                                        activeVitalDevice={props.config.activeDevice}
                                        modeData={props.ventilatorModesData}
                                        bedId={props.bedId}
                                        alarmData={props.alarmData}
                                        handleSeeAllAlarms={props.handleSeeAllAlarms}
                                    />
                                }
                            </div>
                            <div className='ventilator-graphs'>
                                {props?.ventilatorStandby?.ventilationStatus ? (
                                    <VentilatorChart bedId={props.bedId} />
                                ) : (
                                    <div className='standby'>
                                        <img
                                            className='not-in-use-imge'
                                            src={standbyIcon}
                                            alt="Ventilator on Standby"
                                        />
                                        <h2 className='not-in-use-text'>Ventilator is on Standby</h2>
                                    </div>
                                )}
                            </div>
                            <VentilatorSetParams bedId={props.bedId} />
                        </div>

                        {props?.ventilatorStandby?.ventilationStatus &&
                            <div className='param-vitals-container'>
                                {currentPage === 1 &&

                                    <div className='vital-param-boxes-container'>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={0} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={1} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={2} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={3} borderRight={true} />
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={4} borderRight={false} />
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={5} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={6} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={7} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={8} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={9} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={10} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={11} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={12} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={13} borderBottom={false} />
                                            </div>
                                        </div>
                                    </div>
                                }
                                {currentPage !== 1 &&

                                    <div className='vital-param-boxes-container'>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={0} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={1} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={2} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={3} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={4} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={5} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={6} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={7} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={8} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={9} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={10} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={11} borderBottom={false} />
                                            </div>
                                        </div>
                                        <div className='vital-parameter-row'>
                                            <LeftBoxParamContainer currentPage={currentPage} card_no={12} borderRight={true} />
                                            <div className='vital-parameter-right'>
                                                <RightBoxParamContainer currentPage={currentPage} card_no={13} borderBottom={true} />
                                                <RightBoxParamContainer currentPage={currentPage} card_no={14} borderBottom={false} />
                                            </div>
                                        </div>
                                    </div>
                                }

                                <Pagination
                                    currentPage={currentPage}
                                    bedId={props.bedId}
                                    onPageChange={page => setCurrentPage(page)}
                                />
                            </div>
                        }
                    </div >
                )
            }

        } else {
            return (
                <div className='offline'>
                    <img className='not-in-use-imge' src={offlineIcon} alt="Ventilator Offline" />
                    <h2 className='not-in-use-text'>HorizonView is Disabled</h2>
                </div>
            )
        }

    } else {
        return (
            <div className='offline'>
                <img className='not-in-use-imge' src={offlineIcon} alt="Ventilator Offline" />
                <h2 className='not-in-use-text'>Ventilator is currently offline, possibly due to settings or poor internet connection; please check and ensure proper configuration for seamless monitoring.</h2>
            </div>
        )
    }
};

export default VentilatorVitalDataDesktopView;